const config = {
    storagePrefix: 'matrecmsapp_',
    //storagePrefix: 'matrecmsappdev_',
    usaPermessi: false,
    backend: {
        //baseURL: 'http://api.studiotrau.com/', //DEVELOPMENT?
        //baseURL: 'http://api.matrec.studiotrau.com/', //slash finale PRODUCTION
        ////baseURLssl: 'https://api.matrec.studiotrau.com/', //slash finale PRODUCTION
        //baseURLssl: 'https://api.matrec.studiotrau.com/', //slash finale PRODUCTION
        baseURL: 'http://apicirculartool.matrec.com/',
        baseURLssl: 'https://apicirculartool.matrec.com/',

        //autenticazione client oauth
        client_id: 'r1',
        client_secret: 'controllo',
    },
}

export default config;